import { render, staticRenderFns } from "./AgeingOfAccounts.vue?vue&type=template&id=70bc5df9&"
import script from "./AgeingOfAccounts.vue?vue&type=script&lang=js&"
export * from "./AgeingOfAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports